<template>
    <v-dialog v-model="dialogSwitch" persistent scrollable width="500">
        <v-form v-model="formData.valid" class="mb-3" validate-on="input lazy"
                @submit.prevent="assignRole">
            <v-card>
                <v-card-title id="heading" class="d-flex justify-space-between">
                    <h4>Assign Portal</h4>
                    <v-btn density="compact" icon="mdi-close" variant="flat" @click="$emit('update:modelValue',false)"/>
                </v-card-title>

                <v-container>
                    <v-alert v-if="errors.length" class="mb-3 bg-error" closable close-label="Close Alert"
                             density="compact" variant="tonal">
                        <p v-for="error in errors">{{ error }}</p>
                    </v-alert>
                    <v-row>
                        <v-col cols="12">
                            <v-select v-model="formData['role_id']"
                                      :items="roles"
                                      :rules="[vRules.required]"
                                      density="compact"
                                      item-value="id" label="Role"/>
                        </v-col>
                    </v-row>
                </v-container>

                <v-card-actions class="px-4 d-flex justify-end">
                    <v-btn size="small" type="button"
                           @click="$emit('update:modelValue',false)">
                        Close
                    </v-btn>
                    <v-btn :disabled="!formData.valid" color="primary" size="small" type="submit">Save</v-btn>
                </v-card-actions>
            </v-card>
        </v-form>
    </v-dialog>
</template>

<script setup>
import {ref, reactive, onMounted} from "vue";
import {send} from "@/composables/apiClient";
import {useSnackbarStore} from "@/stores/snackBarStore";

const snackbar = useSnackbarStore();
const props = defineProps({
    modelValue: Boolean,
    user: Object,
});
const formData = reactive({
    valid: false,
    portal_id: null,
    user_id: props.user.id,
});
const emits = defineEmits(['update:modelValue']);
const dialogSwitch = ref(props.modelValue);
const roles = ref([]);
const errors = ref([]);

onMounted(() => {
    fetchRoles()
})
const fetchRoles = () => {
    send('get', `admin/roles?type=admin`)
        .then((response) => {
            roles.value = response.data.data;
        })
        .catch((error) => {
            console.log(error)
            snackbar.showSnackbar('Roles could not be loaded', 'error')
        })
}
const assignRole = () => {
    errors.value = [];
    send('post', `admin/assign-roles`, formData)
        .then((response) => {
            snackbar.showSnackbar(response.data.message);
            if (response.data.success) {
                emits('update:modelValue', false);
            }
        })
        .catch(function (errorResponse) {
            if (errorResponse.response.data.errors) {
                let validationErrors = errorResponse.response.data.errors;
                Object.keys(validationErrors).forEach((key) => {
                    errors.value.push(validationErrors[key][0]);
                });
            } else if (errorResponse.response.data.message) {
                errors.value.push(errorResponse.response.data.message);
            }
            snackbar.showSnackbar('Something went wrong', 'error');
            document.getElementById('heading').scrollIntoView({behavior: 'smooth'});
        })
}
</script>
